import { Partners } from '@lockton-apps/shared/interfaces';
import { includes } from 'lodash';

const MMPI_PARTNERS = [
  Partners.ENW,
  Partners.ACCA_OVER,
  Partners.CONSTRUCTION,
  Partners.REGULATORY,
];

const V2_PARTNERS = [
  ...MMPI_PARTNERS,
  Partners.ACCA,
  Partners.NORWAY_PI,
  Partners.NORWAY,
  Partners.LSOS,
];

export function isV2(partner: Partners | string) {
  return includes(V2_PARTNERS, partner);
}
